import { render, staticRenderFns } from "./PopupReativarEmpresa.vue?vue&type=template&id=b0eda288&"
import script from "./PopupReativarEmpresa.vue?vue&type=script&lang=js&"
export * from "./PopupReativarEmpresa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports